<template>
  <bread-crumb list-classes="breadcrumb-links breadcrumb-dark">
    <BreadCrumbItem>
      <li class="breadcrumb-item">
        <router-link to="/">
          <i class="fas fa-home"></i>
        </router-link>
      </li>
    </BreadCrumbItem>
    <BreadCrumbItem
      v-for="(route, index) in breadcrumbs"
      :key="route.name"
      :active="index === currentIndex"
      style="display: inline-block"
    >
      <router-link v-if="index < currentIndex" :to="{ name: route.name }">
        {{ route.meta.title || currentRouteName }}
      </router-link>
      <span v-else>{{ route.meta.title || currentRouteName }}</span>
    </BreadCrumbItem>
  </bread-crumb>
</template>

<script>
import BreadCrumb from './Breadcrumb';
import BreadCrumbItem from './BreadcrumbItem';

export default {
  name: 'RouteBreadcrumb',
  components: {
    BreadCrumb,
    BreadCrumbItem,
  },

  data() {
    return {
      breadcrumbs: [],
    };
  },

  computed: {
    currentIndex() {
      return this.$route.matched.length - 1;
    },

    currentRouteName() {
      return this.$route.name;
    },
  },

  mounted() {
    this.breadcrumbs = this.$route.matched.slice();
  },

  methods: {
    getBreadName(route) {
      return route.name;
    },
  },
};
</script>
